// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3G4iA","inputDescription":"styles_inputDescription__1ah4L"};